import constant from "../constant";
import authHandler from "@/router/authHandler";
import {getStore} from "../api/storeAccessor";

/**
 * Register global functions which can called in any place of the app
 * @type {{unLoadEvent: methods.unLoadEvent}}
 */
const global_methods = {
    /**
     * Prevent unload event and display pop up message
     * @param event
     */
    popupUnloadEvent: (event) => {
        setTimeout(function() {
            setTimeout(function() {
                // They chose to remain on the site
            }, 100);
        },1);
        event.preventDefault();
        event.returnValue = '';

        return '';
    },
    /**
     * Set Component orientation by theme settings
     * applicable : ion-modal
     * @param name
     * @returns {string}
     */
    setComponentOrientation: (name) => {
        let theme = getStore().getters.theme;
        //left align
        if (theme && theme.body_content_align == '0px') {
            name = name + " left-oriented";
        }
        return name;
    },

    getCorrectAriaText: (icon_class) => {
        let language_set = getStore().getters.languageSet;
        switch (icon_class) {
            case 'circular-tick':
                return language_set['key_correct'];

            case 'circular-x':
                return language_set['key_wrong'];

            case  'circular-tick-holo':
                return language_set['key_missed'];

            default:
                return '';
        }
    },


    /**
     * Hack : Ionic Checkbox/Radio Button Label cannot click inside of contents such as link or buttons.
     * in order to make sure it is clickable, using javascript to do it
     * when clicking element is not A or IMG should allow button to be checked
     * click event
     *
     *
     * [ Notes ] - https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault#notes
     * Calling preventDefault() during any stage of event flow cancels the event, meaning that any default action normally taken by the implementation as a result of the event will not occur.
     * You can use Event.cancelable to check if the event is cancelable. Calling preventDefault() for a non-cancelable event has no effect.
     *
     *
     * @param event
     * @param radio_button_id
     */
    multipleChoiceLabelClicked: (event, option_id) => {
        let clickable = event.target.nodeName != 'A' && event.target.nodeName != 'VIDEO'
            && event.target.nodeName != 'AUDIO'
            && (event.target.nodeName != 'IMG' ||
                (event.target.nodeName == 'IMG' && !event.target.classList.contains('magnifying')));

        if (clickable) {
            event.preventDefault();
            let element = document.getElementById(option_id);
            element.click();

        } else if (event.target.nodeName == 'A') {

            /*
                When opening the PDF file in the browser, the PDF file opened in the pdf viewer, but the file is downloaded
                at the same time. Hence, we had to inject 'No-external-link' class to skip the download.
             */

            if(event.target.classList.contains('no-external-link') === false) {
                event.preventDefault();

                //ensure block the event to progress
                let targetUrl = event.target.href;
                window.open(targetUrl);
            }
        }

    },

    namesInReverseOrder: (lang_code) => {
        let countries_name_in_reverse_order = [constant.LANG_CODE_JAPAN, constant.LANG_CODE_KOREA, constant.LANG_CODE_CHINA, constant.LANG_CODE_CHINA_SIMPLE];
        if (countries_name_in_reverse_order.includes(lang_code)) {
            return true;
        }

        return false;
    },

    closePreview: (additional_path = '', link_to_test=false)=>{

        let url = import.meta.env.VITE_APP_CM_DOMAIN;

        const group_id = getStore().getters.groupId;
        const group_type = getStore().getters.groupType;
        const test_id = getStore().getters.testId;
        const track_from_admin_app = getStore().getters.trackFromAdminApp;


        if(link_to_test){
            url = url + '/a/tests/test/?test_id='+test_id;
        }
        else {

            if (group_type === 'link') {

                url = url + '/a/results/tests/test/nrgusers/?show=1&test_id=' + test_id + '&nrg_id=' + group_id + '&return=listresults';
            } else {
                if (group_id === 0) {

                    if (track_from_admin_app === 'test_dashboard') {
                        url = url + '/a/tests/test/dashboard/?test_id=' + test_id;
                    } else {
                        url = url + '/a/tests/test/?test_id=' + test_id + '&trk=edittest_inrow_edit';
                    }

                } else {
                    url = url + '/a/results/tests/test/rgusers/?test_id=' + test_id + '&rg_id=' + group_id + '&active_panel=settings';
                }
            }
        }

        let quiz_id = getStore().getters.quizId;
        authHandler.deleteToken(quiz_id);
        location.href = url + additional_path;

    },

    isFirefox:()=>{
        const userAgent = navigator.userAgent;
        // Convert to lowercase for case-insensitive comparison
        return userAgent.toLowerCase().includes('firefox');
    },

    isSafari:()=>{
        const userAgent = navigator.userAgent;
        return /safari/i.test(userAgent) && !/chrome/i.test(userAgent);
    },

    fadeOutTestContent:()=>{
        const pageElem = document.querySelector('.ion-page.fullscreen-mode');
        const appElem = document.querySelector('#cmTestApp');
        if (!appElem.classList.contains('warning')) {
            if(pageElem) {
                pageElem.style.opacity = 0.3
            }
            appElem.classList.add('warning');
        }
    },
    fadeInTestContent:()=>{
        const pageElem = document.querySelector('.ion-page.fullscreen-mode');
        const appElem = document.querySelector('#cmTestApp');
        if (appElem.classList.contains('warning')) {
            if(pageElem) {
                pageElem.style.opacity = 1;
            }
            appElem.classList.remove('warning');
        }
    }



}

export default global_methods;




